<!-- No resources message -->
<div
  class="flex-row align-items-center justify-content-center"
  style="margin: 0 auto; padding: 48px"
  *ngIf="noResources && !loading"
>
  {{ emptyMessageKey | translate }}
</div>

<!-- Table content wrapper with loading overlay -->
<div class="table-wrapper" [class.loading]="loading" [style.min-height.px]="containerHeight" *ngIf="!noResources">
  <!-- Loading overlay - preserves the space while showing loading state -->
  <div class="loading-overlay" *ngIf="loading">
    <div class="loading-content">
      <i class="ri-loader-4-line spin"></i>
      {{ 'info.loading_data' | translate }}
    </div>
  </div>

  <!-- Table content - visible but dimmed during loading -->
  <table mat-table [dataSource]="items" class="spotlab-table" matSort style="width: 100%" [class.dimmed]="loading">
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.type' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let resource" class="type-cell">
        {{ resource.type }}
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.name' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let resource" class="name-cell">
        {{ resource.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="nestedResources">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.nested_resources' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let resource" class="nested-count-cell">
        {{ resource.nestedResourcesCount }}
      </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let resource" class="icon-cell">
        <button
          class="icon-button"
          type="button"
          (click)="editClicked.emit(resource); $event.stopPropagation()"
          data-cy="resource-edit"
        >
          <i class="ri-pencil-line"></i>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let resource" class="icon-cell">
        <button
          class="icon-button danger"
          type="button"
          (click)="deleteClicked.emit(resource); $event.stopPropagation()"
          data-cy="resource-delete"
        >
          <i class="ri-delete-bin-6-line"></i>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="assigned">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let resource" class="icon-cell">
        <button
          class="icon-button assigned-toggle"
          [class.assigned]="resource.assigned"
          type="button"
          [matTooltip]="(resource.assigned ? 'label.unassign' : 'label.assign') | translate"
          [matTooltipShowDelay]="1000"
          (click)="assignedToggled.emit(resource); $event.stopPropagation()"
          data-cy="resource-assigned"
        >
          <i [class]="resource.assigned ? 'ri-checkbox-circle-fill' : 'ri-add-circle-line'"></i>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="visibleColumns"></tr>
    <tr mat-row *matRowDef="let resource; columns: visibleColumns"></tr>
  </table>
</div>
